import React from 'react';
import { useNavigate } from 'react-router';

import styled from '@emotion/styled';

import { FormSubmitBtn } from '../../../components/Button/FormSubmitButton';
import GreenCheckBadgeIcon from '../../../components/Icons/GreenCheckBadgeIcon';
import { ACCOUNT, SIGNIN } from '../../../routes/routeConstants';

const SignupVerificationConfirmation: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Container>
      <FormWrapper>
        <HeaderSection>
          <GreenCheckBadgeIcon />
          <HeaderText>
            <div className='title'>Verify your Account</div>
            <div className='description'>
              Your Verification has been completed successfully.
            </div>
          </HeaderText>
        </HeaderSection>
        <FormSubmitBtn
          className='fill'
          onClick={() => {
            navigate(`/${ACCOUNT}/${SIGNIN}`, {
              replace: true,
            });
          }}
        >
          Continue to Application
        </FormSubmitBtn>
      </FormWrapper>
    </Container>
  );
};

export default SignupVerificationConfirmation;

const Container = styled.div`
  display: flex;
  height: 100vh;
  color: ${({ theme }) => theme.palette.grayTextColor};
  /* background-color: red; */
  background-color: ${({ theme }) => theme.palette.pageBgColor};
`;

const FormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 596px;
  align-self: center;
  gap: 24px;
  margin: auto;
`;

const HeaderSection = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 32px;
`;

const HeaderText = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 16px;
  text-align: center;
  margin-bottom: 4px;

  & > .title {
    font-weight: 600;
    font-size: 20px;
    line-height: 27px;
    color: ${({ theme }) => theme.palette.logirateBlack};
  }

  & > .description {
    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
  }
`;
